<template>
  <div>
    <v-alert dense outlined type="info" color="primary" class="mb-5">
      Por padrão, este usuário administrador pode editar dados de qualquer versão de BDGD das empresas às quais tem acesso de
      Administrador. Mova uma versão para
      <strong>Bloqueadas</strong>
      para impedir a edição dela.
    </v-alert>
    <base-dual-list-transfer
      v-model="versoesBloqueadasIds"
      :items="versoesDisponiveis"
      :loading="loading"
      left-title="Bloqueadas"
      left-icon="mdi-lock"
      right-title="Pode editar"
      right-icon="mdi-lock-open-check"
      search-label="Pesquisar versão"
      select-all-label="Bloquear todas"
      clear-label="Limpar bloqueadas"
      item-value="id"
      item-text="label"
    />
  </div>
</template>

<script>
  import BdgdVersionsService from '@/services/BdgdVersionsService';
  import PermissoesEdicaoBdgdService from '@/services/PermissoesEdicaoBdgdService';
  import dateFormatterMixins from '@/mixins/dateFormatterMixins';

  export default {
    name: 'ThirdTabContent',

    mixins: [dateFormatterMixins],

    props: {
      usuarioId: {
        type: [Number, String],
        required: true
      },
      acessos: {
        type: Array,
        default: () => []
      }
    },

    data: () => ({
      loading: false,
      versoesDisponiveis: [],
      versoesBloqueadasIds: []
    }),

    computed: {
      empresasAdministradas() {
        const vistos = new Set();
        return this.acessos.filter((acesso) => {
          if (acesso.perfil !== 'Administrador' || vistos.has(acesso.id)) return false;
          vistos.add(acesso.id);
          return true;
        });
      }
    },

    mounted() {
      this.carregarVersoesDisponiveis();
      this.carregarVersoesBloqueadas();
    },

    methods: {
      async carregarVersoesDisponiveis() {
        this.loading = true;
        try {
          const listasPorEmpresa = await Promise.all(
            this.empresasAdministradas.map((empresa) => BdgdVersionsService.getAllBdgdVersionsByCompanyId(empresa.id))
          );
          this.versoesDisponiveis = listasPorEmpresa.flatMap((versoes, indice) => {
            const empresa = this.empresasAdministradas[indice];
            return versoes.map((versao) => ({
              id: versao.id,
              label: `${empresa.empresa} — ${this.formatMonth(versao.data_registro)} v${versao.versao}`
            }));
          });
        } catch (error) {
          console.log('Erro: ', error);
          this.$toast.error('Erro ao buscar as versões de BDGD das empresas administradas pelo usuário.', '', {
            position: 'topRight'
          });
        } finally {
          this.loading = false;
        }
      },

      carregarVersoesBloqueadas() {
        PermissoesEdicaoBdgdService.listarVersoesBloqueadas(this.usuarioId)
          .then((response) => (this.versoesBloqueadasIds = response.data))
          .catch(() =>
            this.$toast.error('Erro ao buscar as versões de BDGD bloqueadas para este usuário.', '', {
              position: 'topRight'
            })
          );
      },

      async sincronizarVersoesBloqueadas() {
        try {
          await PermissoesEdicaoBdgdService.sincronizarVersoesBloqueadas(this.usuarioId, this.versoesBloqueadasIds);
          return true;
        } catch (error) {
          console.log('Erro: ', error);
          this.$toast.error('Erro ao salvar as versões de BDGD bloqueadas para este usuário.', '', {
            position: 'topRight'
          });
          return false;
        }
      }
    }
  };
</script>
